__webpack_require__.p = "/cdn-assets/assistant-ui/";